import Nullstack from 'nullstack';
export default function IconListDetails({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-list-details",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M13 5h8"
  }), "   ", Nullstack.element("path", {
    d: "M13 9h5"
  }), "   ", Nullstack.element("path", {
    d: "M13 15h8"
  }), "   ", Nullstack.element("path", {
    d: "M13 19h5"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "4",
    width: "6",
    height: "6",
    rx: "1"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "14",
    width: "6",
    height: "6",
    rx: "1"
  }), " ");
}